


























































import { Component, Vue, Prop, Emit, Ref } from "vue-property-decorator";
import { TopExpertsTableData } from "@/types";

@Component({
  name: "BiTopExperts",
})
export default class BiTopExperts extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<TopExpertsTableData>;
  @Prop({ type: Boolean, default: false }) viewByTask!: Boolean;
  @Ref('videoRef') videoRef!: HTMLVideoElement;

  @Emit('getTask')
  getTask() {}

  isOpenDialog = false;
  videoUrl: string | null = ''
  defaultAvatarUrl: string = 'https://dev.merezha.com.ua/_nuxt/b79902976e6adfc6a99f97e93370d53e.svg'

  getLink(link: string) {
    return link && !link.includes('http') ? `${process.env.VUE_APP_UPLOAD_URL}/${link}` : link;
  }

  closeDialog() {
    this.isOpenDialog = false;
  }


  async showVideo(link: string, name: string, id: string) {
    this.$gtag.event(`BI_expert_video_${id}-${name}`)
    this.isOpenDialog = !this.isOpenDialog
    this.videoUrl = this.getLink(link)
    await this.$nextTick()
    this.videoRef.play()
  }

  stopVideo() {
    this.videoRef.pause()
  }
}

